
export function groupBy(xs, key) {
    return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};

export function uniqueFilter(value, index, self) {
    return self.indexOf(value) === index;
}

const amountFormat = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", minimumFractionDigits: 0, maximumFractionDigits: 0})
const numberFormat = new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 1})
const roundedNumberFormat = new Intl.NumberFormat("fr-FR", { minimumFractionDigits: 0, maximumFractionDigits: 0})


export function formatAmount(amount) {
    if (amount > 1000000) {
        return `${numberFormat.format((amount / 1000000))} millions\u00a0€`
    } else {
        return amountFormat.format(amount);
    }
}

export function formatNumber(number) {
    return numberFormat.format(number)
}

export function formatRoundedNumber(number) {
    return roundedNumberFormat.format(number)
}

export function logMatomoEvent(category, action, name, value) {
    /*if (_paq && _paq.push) {
        _paq.push(['trackEvent', `v3-${category}`, `${category}:${action}`, name, value])
    }*/
}


const region_prefix_a = ['974'];
const region_prefix_dans_les = ['32','52'];

export function getRegionWithPrefix(region) {
    var prefix = "En ";
    if (region_prefix_a.indexOf(region.id) !== -1) {
        prefix = "À ";
    } else if (region_prefix_dans_les.indexOf(region.id) !== -1) {
        prefix = "Dans les ";
    }
    return prefix + region.name;
}


const dept_prefix_a = ['75','974'];
const dept_prefix_dans_l = ['01','02','03','10','11','12','27','34','36','60','61','89'];
const dept_prefix_dans_la = ['23','26','42','50','51','58','72','80','86'];
const dept_prefix_dans_le = ['14','15','18','25','29','30','32','39','45','46','47','49','56','59','62','63','67','68','69','81','82','83','84','90','94','95'];
const dept_prefix_dans_les = ['04','05','06','08','13','22','40','64','65','66','78','79','88','92'];

export function getDeptWithPrefix(dept) {
    var prefix = "En ";
    if (dept_prefix_a.indexOf(dept.id) !== -1) {
        prefix = "À ";
    } else if (dept_prefix_dans_l.indexOf(dept.id) !== -1) {
        prefix = "Dans l'";
    } else if (dept_prefix_dans_la.indexOf(dept.id) !== -1) {
        prefix = "Dans la ";
    } else if (dept_prefix_dans_le.indexOf(dept.id) !== -1) {
        prefix = "Dans le ";
    } else if (dept_prefix_dans_les.indexOf(dept.id) !== -1) {
        prefix = "Dans les ";
    }
    return prefix + dept.name;
}

export function formatLocation(locationWithPrefix, capitalize) {
    if (capitalize) {
        return locationWithPrefix.charAt(0).toUpperCase() + locationWithPrefix.slice(1);
    } else {
        return locationWithPrefix.charAt(0).toLowerCase() + locationWithPrefix.slice(1);
    }
}